module.exports = __webpack_public_path__ + "media/images/illustrations/basic_materials_box-c91a53ff1c4cfc7fc7467474e3d0fb6b.svg";